import { h } from "preact";
import { useMemo } from "preact/hooks";
import { observer } from "mobx-react";
import FieldError from "./FieldError";
import FieldLabel from "./FieldLabel";
function DateField(props) {
    const { controller, dates, min, max, name, label, hideLabel = false, autocomplete, placeholder, required = false, disabled = false, autofocus = false, dataFieldId, } = props;
    const handleChange = (event) => {
        const value = event.target.value;
        controller.change(value);
        // Blur on date select to show errors, eg. invalid date error
        controller.blur();
    };
    const hasError = controller.isTouched && controller.isInvalid;
    const isSuccess = controller.isTouched && controller.isValid;
    // NOTICE: We are using Select input as a fallback for browsera that don't support `min` & `max` prop in the calendar input (Safari / iOS).
    // This is temporary solution until we will make calendar picker better.
    // For calendar picker the best choice from tested ~10 libraries (features, bundle size, a11y & keyboard navigation support) is `wc-datepicker`.
    const isSelectViewActive = useMemo(isSafariOrIOS, []);
    return (h("div", { class: `form-group m_form-group form-field ${hasError ? "has-error" : ""} ${isSuccess ? "success" : ""}`, "data-field-id": dataFieldId },
        h(FieldLabel, { isRequired: required, isHidden: hideLabel, htmlFor: name }, label),
        isSelectViewActive ? (h(SelectView, { controller: controller, options: dates || [] })) : (h("input", { id: name, name: name, onChange: handleChange, onBlur: () => controller.blur(), value: controller.value, min: min, max: max, type: "date", pattern: "\\d{4}-\\d{2}-\\d{2}", autofocus: autofocus, autocomplete: autocomplete, placeholder: placeholder, required: required, disabled: disabled, class: "form-control u-text-normal" })),
        hasError && h(FieldError, { errors: controller.errors })));
}
const SelectView = observer((props) => {
    const { controller, options } = props;
    const handleChange = (event) => {
        const value = event.target.value;
        controller.change(value);
    };
    return (h("div", { class: "m-select" },
        h("select", { onChange: handleChange, value: controller.value, class: "form-control m-select__select" }, options.map((option) => (h("option", { value: option.value, key: option.value }, option.label))))));
});
// NOTICE: This is a private function because it is not checked properly yet and is used only here.
function isSafariOrIOS() {
    const iOS_1to12 = /iPad|iPhone|iPod/.test(navigator.platform);
    const iOS13_iPad = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    const iOS = !window.MSStream && (iOS_1to12 || iOS13_iPad);
    const safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return iOS || safari;
}
export default observer(DateField);
